import SelectPokemon from "./Select";
export default SelectPokemon;